<template>
  <div>
    <img class="crisp-image" src="../../../assets/images/modals/ico055.svg" alt="Order Prescription">
    <text-string label-id="txt361" class="m-b-10"/>
    <text-string label-id="txt362"/>
  </div>
</template>

<script>
  export default {
    name: "modal-view-pharmacy-orders-step-one"
  }
</script>

<style scoped>

</style>